import { PlusIcon } from '@heroicons/react/20/solid';
import { Trans, useTranslation } from 'next-i18next';
import { buildSearchParams } from '@utils/data-fetching';
import { useExtendedRouter } from '@hooks/next-routing-wrappers';
import sendGoogleTagEvent from '@hooks/useSendGoogleTagEvent';

/**
 * @description Banner component for adding a job from talent search .
 */

interface IProps {
  keyword: string;
  locale: Locale;
}

export const BannerForJobAdd = ({ keyword }: IProps) => {
  const { t } = useTranslation('common');
  const { router } = useExtendedRouter();

  const handleCtaClick = () => {
    sendGoogleTagEvent('add_job_cta_teaser_click', 'Custom');
    // ?keyword= pre-fills the title on the job-add form. The old previousJobId param was
    // dead — nothing in the current job-add flow consumed it.
    router.push(`/job-add/edit${buildSearchParams({ keyword })}`);
  };

  return (
    // The whole banner is the CTA — no separate Add-job button (it crowded the layout on
    // mobile); clicking anywhere goes to the add-job page.
    <div
      role="presentation"
      onClick={handleCtaClick}
      className="gt-click-from-banner-add-job my-3 cursor-pointer rounded-lg border border-dotted border-secondary bg-surface p-2 md:rounded-full md:p-4"
    >
      <div className="flex flex-wrap items-center justify-between">
        <div className="flex items-center">
          <div className="mr-2 mt-1 w-fit rounded-full bg-secondary/20 p-2 md:mr-4 md:mt-0">
            <span className="flex items-center justify-center rounded-full bg-secondary p-1 text-white">
              <PlusIcon className="size-5 stroke-2 md:size-6" />
            </span>
          </div>
          <div>
            <h3 className="text-sm font-bold text-ink md:text-md">
              <Trans
                i18nKey="banner.add.job.by.keyword.title"
                values={{
                  keyword,
                }}
              />
            </h3>
            <p className="m-0 text-sm font-thin text-ink md:text-md">{t('banner.add.job.by.keyword.description')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
